import { render, staticRenderFns } from "./JokePage.vue?vue&type=template&id=578d70f8&scoped=true&"
import script from "./JokePage.vue?vue&type=script&lang=js&"
export * from "./JokePage.vue?vue&type=script&lang=js&"
import style0 from "./JokePage.vue?vue&type=style&index=0&id=578d70f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578d70f8",
  null
  
)

export default component.exports